import { computed, Ref } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { parseISO } from "@scrile/tools/dist/lib/TimeHelpers";
import { format } from "@/lib/time";

export default function useFeedCoverIcons(authUserId: Ref<string>, postData: Ref<ContentFeed | ContentSet>) {
  const isAuthor = computed(() => authUserId.value === postData.value.userId);
  const showErrorIcon = computed(() => postData.value.processingStatus === "ERROR");
  const showProcessingIcon = computed(() => ["NEW", "CONVERTING"].indexOf(postData.value.processingStatus) > -1);
  const showScheduledIcon = computed(
    () => !!postData.value.scheduleTime && parseISO(postData.value.scheduleTime).getTime() >= Date.now()
  );
  const scheduledText = computed(() =>
    postData.value.scheduleTime ? format(parseISO(postData.value.scheduleTime), "MM.dd.yy") : ""
  );
  const isNotPublished = computed(() => !postData.value.publishTime);

  const showGradient = computed(
    () =>
      isAuthor.value &&
      (showErrorIcon.value || showProcessingIcon.value || showScheduledIcon.value || isNotPublished.value)
  );

  return {
    isAuthor,
    showGradient,
    showErrorIcon,
    showProcessingIcon,
    showScheduledIcon,
    scheduledText,
    isNotPublished,
  };
}
